import { __awaiter, __generator } from "tslib";
import { fetchPostAsResponse } from '../../../common';
import { getAuthBearerValue } from '../../../common/utilities';
import { getWebStoreApiConfig } from '../config/actions';
import { getTokenFromHeaders } from './get-token-from-headers';
/**
 * Refreshes either guest or auth JWT.
 * @param token Previous JWT
 * @param accessToken Access JWT
 * @returns Promise with new JWT.
 */
export var refreshToken = function (token, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, baseUrl, storage, siteContext, marketLocale, body, url, headers, response, newToken, storageKey;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getWebStoreApiConfig(), baseUrl = _a.baseUrl, storage = _a.storage, siteContext = _a.siteContext, marketLocale = _a.marketLocale;
                body = { brand: siteContext, marketLocale: marketLocale, previousToken: token };
                url = baseUrl + "/" + "v1/tokens/refresh" /* RefreshTokens */;
                headers = new Headers();
                if (!!accessToken) {
                    headers.set("Authorization" /* Authorization */, getAuthBearerValue(accessToken));
                }
                return [4 /*yield*/, fetchPostAsResponse(url, body, { headers: headers })];
            case 1:
                response = _b.sent();
                if (!response || !response.ok) {
                    return [2 /*return*/, Promise.reject('Failed to refresh token from Web Store API')];
                }
                newToken = getTokenFromHeaders(response.headers);
                if (!newToken) {
                    return [2 /*return*/, Promise.reject('Authorization header was not found in refresh token response')];
                }
                storageKey = !!accessToken ? "web-store-auth-token" /* WebStoreAuthToken */ : "web-store-guest-token" /* WebStoreGuestToken */;
                storage.setItem(storageKey, newToken);
                return [2 /*return*/, newToken];
        }
    });
}); };
